/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Kvkkbasvuru_S5_Intro_PreInputs */

const tr_kvkkbasvuru_s5_intro_pre = /** @type {(inputs: Kvkkbasvuru_S5_Intro_PreInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Aşağıdaki örnek metni kullanarak başvurunuzu `)
};

const en_kvkkbasvuru_s5_intro_pre = /** @type {(inputs: Kvkkbasvuru_S5_Intro_PreInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Using the sample text below, you can send your application to `)
};

const de_kvkkbasvuru_s5_intro_pre = /** @type {(inputs: Kvkkbasvuru_S5_Intro_PreInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mit dem folgenden Mustertext können Sie Ihren Antrag an `)
};

const ru_kvkkbasvuru_s5_intro_pre = /** @type {(inputs: Kvkkbasvuru_S5_Intro_PreInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Используя приведённый ниже образец текста, вы можете направить своё обращение на `)
};

/**
* | output |
* | --- |
* | "Using the sample text below, you can send your application to" |
*
* @param {Kvkkbasvuru_S5_Intro_PreInputs} inputs
* @param {{ locale?: "tr" | "en" | "de" | "ru" }} options
* @returns {LocalizedString}
*/
export const kvkkbasvuru_s5_intro_pre = /** @type {((inputs?: Kvkkbasvuru_S5_Intro_PreInputs, options?: { locale?: "tr" | "en" | "de" | "ru" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Kvkkbasvuru_S5_Intro_PreInputs, { locale?: "tr" | "en" | "de" | "ru" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_kvkkbasvuru_s5_intro_pre(inputs)
	if (locale === "de") return de_kvkkbasvuru_s5_intro_pre(inputs)
	if (locale === "ru") return ru_kvkkbasvuru_s5_intro_pre(inputs)
	return tr_kvkkbasvuru_s5_intro_pre(inputs)
});